import Bout from "../../bout/Bout.js";
import Player from "../../bout/Player.js";
import Bar from "./bar/Bar.js";

export default class Status {
	constructor(paperdoll,callback) {
		this.paperdoll = paperdoll;
		this.callback = callback;
		this.checkUpd = new Object();
	}

	init() {
		this.mc = jQuery("#template-status").clone();
		this.mc.attr("id", "status" + Status.ENUM++);
		this.player = Bout.that.player;
		this.build();
		jQuery(".js-skills", this.mc).on("click", this.openSkill.bind(this));
		
	}
	getClip() {
		return this.mc;
	}
	destroy() {

	}
	dispatch(e) {
		if (this.callback) {
			this.callback.call(null, e);
		}
	}
	openSkill() {
		this.dispatch({ type: Status.EVENT_OPEN_SKILLS });
	}


	build() {
		this.healthBar = new Bar(jQuery(".js-health-bar", this.mc), "#template-bar", "icon_health.png", "nock_health.png", 0, this.player.max_hp, this.player.hp);
		this.healthBar.init();
		this.foodBar = new Bar(jQuery(".js-food-bar", this.mc), "#template-bar", "icon_food.png", "nock_food.png", 0, this.player.max_food, this.player.food);
		this.foodBar.init();
		this.waterBar = new Bar(jQuery(".js-water-bar", this.mc), "#template-bar", "icon_water.png", "nock_water.png", 0, this.player.max_water, this.player.water);
		this.waterBar.init();
		this.update();
	}


	update() {

		this.checkIfUpdateAndUpdate(".js-hp", "hp");
		this.checkIfUpdateAndUpdate(".js-hp-max", "max_hp");
		this.checkIfUpdateAndUpdate(".js-level", "currentLevel");
		this.checkIfUpdateAndUpdate(".js-xp", "xp");
		this.checkIfUpdateAndUpdate(".js-xp-next-level", "xpNextLevel");

		this.checkIfUpdateAndUpdate(".js-damage", "dmg", this.paperdoll.getDamage.bind(this.paperdoll));
		this.checkIfUpdateAndUpdate(".js-armour", "arm", this.paperdoll.getArmour.bind(this.paperdoll));
		this.checkIfUpdateAndUpdate(".js-speed", "spd", this.paperdoll.getSpeed.bind(this.paperdoll));

		this.waterBar.setValue(this.player.water);
		this.foodBar.setValue(this.player.food);
		this.healthBar.setValue(this.player.hp);

		this.setAlterations();
	}


	checkIfUpdateAndUpdate(target, prop, funct) {
		if (funct) {
			let value = funct.call(null,this);
			if (this.checkUpd[prop] != value) {
				this.checkUpd[prop] = value;
				jQuery(target, this.mc).text(value);
			}

		} else {
			if (this.checkUpd[prop] != this.player[prop]) {
				this.checkUpd[prop] = this.player[prop];
				jQuery(target, this.mc).text(this.player[prop]);
			}
		}

	}

	checkIfUpdate(prop) {
		if (this.checkUpd[prop] != this.player[prop]) {
			this.checkUpd[prop] = this.player[prop];
			return true;
		}
		return false;
	}

	setAlterations() {
		let html = "";
		let lUpd = false;
		//jQuery(".js-alterations", this.mc).html("");
		if ((this.checkIfUpdate("water")) || (this.checkIfUpdate("food"))) {
			lUpd = true;
			if (this.player.water < Player.PLAYER_THIRSTY) {
				let div = jQuery("<div></div>");
				let tmp = jQuery("#template-alteration-thirsty").clone();
				tmp.removeAttr("id")
				div.append(tmp);
				html += div.html();
			}
			if (this.player.food < Player.PLAYER_HUNGRY) {
				let div = jQuery("<div></div>");
				let tmp = jQuery("#template-alteration-hungry").clone();
				tmp.removeAttr("id")
				div.append(tmp);
				html += div.html();
			}
		}
		if (this.checkIfUpdate("poisoned")) {
			lUpd = true;
			if (this.player.poisoned) {
				let div = jQuery("<div></div>");
				let tmp = jQuery("#template-alteration-poisoned").clone();
				tmp.removeAttr("id")
				div.append(tmp);
				html += div.html();
			}
		}
		if (this.checkIfUpdate("bleeding")) {
			lUpd = true;
			if (this.player.bleeding) {
				let div = jQuery("<div></div>");
				let tmp = jQuery("#template-alteration-bleeding").clone();
				tmp.removeAttr("id")
				div.append(tmp);
				html += div.html();
			}
		}

		if (lUpd) {
			jQuery(".js-alterations", this.mc).html(html);
		}


	}


}
Status.ENUM = 0;
Status.EVENT_OPEN_SKILLS = "eventOpenSkills"